import Styled from './providerImagesOrButtonForUpload.module.css'
import { ProviderImagesOrButtonForUploadProps } from '../../Context/types'
import { LandingContext } from '../../Context'
import { useContext } from 'react'
import { ButtonImage } from '../Global'
import { FiEdit, FiUpload } from 'react-icons/fi'

function ProviderImagesOrButtonForUpload({ value }: ProviderImagesOrButtonForUploadProps) {
    const { handleUploadImage, handleDeleteImage } = useContext(LandingContext)

    return (
        <>
            {
                value.url.length > 0 ?
                    (
                        <ButtonImage background={value.url} type="button" className={Styled.background_clear} onClick={() => handleDeleteImage(value)}>
                            <FiEdit />
                        </ButtonImage>
                    )
                    :
                    (
                        <label className={Styled.background_upload}>
                            <input hidden type="file" onChange={e => handleUploadImage(e, value)} />
                            <FiUpload />
                        </label>
                    )
            }
        </>
    )
}

export default ProviderImagesOrButtonForUpload